export default {
  escape: require('./escape.vue'),
  back: require('./back.vue'),
  jump: require('./jump.vue'),
  newWorkflow: require('./newWorkflow.vue'),
  submit: require('./submit.vue'),
  postback: require('./postback.vue'),
  stripe: require('./stripe.vue')
}



// WEBPACK FOOTER //
// ./src/components/inputs/buttons/_sub/index.js